<main id="main-content" class="main-content">
    <h2 class="form-header">5. Recommended Treatment Narratives</h2>

    <div *ngFor="let forest of forests; let i = index" class="forest-container">
        <h2 class="forest-title">{{ forest.forest_name }}</h2>
        <h3 class="treatment-title">Treatments <span class="thin"><i>(Source: GIS):</i></span> {{ countGISTreatments(i)
            }} | New Treatments: {{ countNewTreatments(i) }} | Total Treatments: {{ treatments[i].length }}</h3>
        <mat-accordion [multi]="true" #accordion="matAccordion">
            <mat-expansion-panel class="treatment-container" [expanded]="true" hideToggle
                *ngFor="let treatment of treatments[i]; let j = index" (opened)="treatment.open = true"
                (closed)="treatment.open = false" (click)="onTreatmentClick($event, accordion)"
                (onkeypress)="onTreatmentKeypress($event, accordion)" onkeypress="">
                <mat-expansion-panel-header>

                    <mat-panel-title class="treatment-title">
                        <i class="material-icons green-arrow" *ngIf="treatment.open">keyboard_arrow_down</i>
                        <i class="material-icons green-arrow" *ngIf="!treatment.open">chevron_right</i>
                        <div class="treatment-title-info">
                            <div>{{ j+1 }}. {{ forest.forest_name }}</div>
                            <span class="thin">
                                {{treatment.option?.treatment_option}}
                                ({{treatment.option?.unit_of_measure}})
                                (Spec.{{treatment.specs[0].specification_number}})
                            </span>
                        </div>
                        <mat-chip *ngIf="treatment.new" class="mat-chip-new">
                            NEW
                        </mat-chip>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div *ngFor="let spec of treatment.specs">
                    <div class="text-div">
                        <b>Treatment Narrative</b>
                        <br>
                        <div class="text" [innerHTML]="customATOB(spec.treatment_narrative || '--')"></div>
                    </div>
                    <div class="row" style="margin-left: 18px;" *ngIf="spec.specification_sheet"><a [href]="decodeURI(spec.specification_sheet)"
                            target="_blank">Spec. Sheet <fa-icon class="fa-sm" [icon]="faExternalLink"></fa-icon></a>
                    </div>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
    </div>
</main>